import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Clock } from "lucide-react";
import { easeOut } from "@/components/common/Reveal";

/** Reusable formation card with hover micro-interactions. */
export default function FormationCard({ formation, categorySlug, index = 0 }) {
  const to = `/nos-formations/${categorySlug || formation.category}/${formation.slug}`;
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, ease: easeOut, delay: (index % 3) * 0.08 }}
    >
      <Link
        to={to}
        className="group flex h-full flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-[0_2px_8px_rgba(0,35,102,0.04)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_48px_rgba(0,35,102,0.12)]"
        data-testid={`formation-card-${formation.slug}`}
      >
        <div className="relative aspect-[16/10] overflow-hidden">
          <img
            src={formation.image}
            alt={formation.title}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-brand-blue/40 to-transparent" />
          {formation.duree && (
            <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-white/90 px-3 py-1 text-xs font-medium text-brand-blue backdrop-blur">
              <Clock className="h-3 w-3" /> {formation.duree}
            </span>
          )}
        </div>
        <div className="flex flex-1 flex-col p-6">
          <h3 className="font-display text-lg font-bold leading-snug text-brand-blue">
            {formation.title}
          </h3>
          <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-500">{formation.resume}</p>
          <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-red">
            Découvrir
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </span>
        </div>
      </Link>
    </motion.div>
  );
}
